
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StickyConsultationButton from '../../components/feature/StickyConsultationButton';
import OverseasHeroSection from './components/OverseasHeroSection';
import OverseasServicesSection from './components/OverseasServicesSection';
import OverseasPricingSection from './components/OverseasPricingSection';
import OverseasStrengthsSection from './components/OverseasStrengthsSection';
import OverseasContactSection from './components/OverseasContactSection';

export default function OverseasOwnersPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Tokyo Minpaku Full Support for Overseas Owners | Complete Peace of Mind from Abroad | Tokyo Local Concierge';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Complete minpaku management support for overseas property owners in Tokyo. From license application to daily operations, tax filing, and English reporting. 150+ properties managed with 98% satisfaction rate. Full English support available 24/7.');
    setMeta('keywords', 'Tokyo minpaku overseas owners, Japan vacation rental management, overseas property management Tokyo, minpaku license application, non-resident tax support Japan, English minpaku support Tokyo');
    setMeta('og:title', 'Tokyo Minpaku Full Support for Overseas Owners | Tokyo Local Concierge', true);
    setMeta('og:description', 'Complete peace of mind from overseas. Full-service minpaku management in Tokyo with English support, tax filing assistance, and transparent monthly reporting.', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://tokyolocalconcierge.com/overseas-owners', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Tokyo Minpaku Full Support for Overseas Owners');
    setMeta('twitter:description', 'Complete peace of mind from overseas. Full-service minpaku management in Tokyo with English support.');
    setMeta('geo.region', 'JP-13');
    setMeta('geo.placename', 'Tokyo');
    setMeta('geo.position', '35.6762;139.6503');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://tokyolocalconcierge.com/overseas-owners');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main>
        <OverseasHeroSection />
        <OverseasServicesSection />
        <OverseasStrengthsSection />
        <OverseasPricingSection />
        <OverseasContactSection />
      </main>

      <Footer />
      <StickyConsultationButton />
    </div>
  );
}
